import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import axios from "axios";

import App from "./App";
import { ThemeProvider } from "./components/theme-provider";
import { BrowserRouter } from "react-router-dom";

// Set axios base URL from environment variable
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <ThemeProvider
                attribute="class"
                defaultTheme="dark"
                enableSystem
                disableTransitionOnChange
            >
                <App />
            </ThemeProvider>
        </BrowserRouter>
    </React.StrictMode>,
);
